import React from 'react';
import { Helmet } from 'react-helmet-async';

const StructuredData = () => {
  // 网站基本信息结构化数据
  const websiteData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "股票信号网",
    "alternateName": "StockSignals",
    "url": "https://stocksignals.cn",
    "description": "专业的A股龙虎榜数据分析平台，提供实时港股美股行情，金融工具包含仓位管理计算器、风险评估工具。",
    "inLanguage": "zh-CN",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://stocksignals.cn/search?q={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  };

  // 组织信息结构化数据
  const organizationData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "股票信号网",
    "url": "https://stocksignals.cn",
    "logo": {
      "@type": "ImageObject",
      "url": "https://stocksignals.cn/logo.png",
      "width": 200,
      "height": 200
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": "Chinese"
    },
    "sameAs": [
      "https://stocksignals.cn"
    ]
  };

  // 金融服务结构化数据
  const financialServiceData = {
    "@context": "https://schema.org",
    "@type": "FinancialService",
    "name": "股票数据分析服务",
    "description": "提供A股龙虎榜、港股美股实时数据分析和金融工具服务",
    "provider": {
      "@type": "Organization",
      "name": "股票信号网",
      "url": "https://stocksignals.cn"
    },
    "serviceType": "金融数据分析",
    "areaServed": {
      "@type": "Country",
      "name": "中国"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "金融工具服务",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "A股龙虎榜数据分析",
            "description": "实时A股龙虎榜数据查询和分析"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "港股美股行情",
            "description": "实时港股美股行情数据"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "仓位管理计算器",
            "description": "专业的投资仓位管理和风险控制工具"
          }
        }
      ]
    }
  };

  // 软件应用结构化数据
  const softwareApplicationData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "股票信号网",
    "description": "专业的股票数据分析平台",
    "url": "https://stocksignals.cn",
    "applicationCategory": "FinanceApplication",
    "operatingSystem": "Web Browser",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "CNY"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "ratingCount": "1000",
      "bestRating": "5",
      "worstRating": "1"
    }
  };

  // 面包屑导航结构化数据
  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "首页",
        "item": "https://stocksignals.cn"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "A股龙虎榜",
        "item": "https://stocksignals.cn/longhubang"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "金融工具",
        "item": "https://stocksignals.cn/tools"
      }
    ]
  };

  return (
    <Helmet>
      {/* 网站基本信息 */}
      <script type="application/ld+json">
        {JSON.stringify(websiteData)}
      </script>
      
      {/* 组织信息 */}
      <script type="application/ld+json">
        {JSON.stringify(organizationData)}
      </script>
      
      {/* 金融服务信息 */}
      <script type="application/ld+json">
        {JSON.stringify(financialServiceData)}
      </script>
      
      {/* 软件应用信息 */}
      <script type="application/ld+json">
        {JSON.stringify(softwareApplicationData)}
      </script>
      
      {/* 面包屑导航 */}
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbData)}
      </script>
    </Helmet>
  );
};

export default StructuredData;